<template>
  <div class="relative">
    <div class="">
      <TestimonialDetailsPopup
        :isActive="isDetailsActive"
        :selectedTesimonial="selectedTesimonial"
        @close="toggleDetails"
      />
      <div class="relative flex">
        <div class="absolute bg-designGT mob-hidden">
          <img src="../../../assets/images/bg-des/bgdTG.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design-dots-tsm">
          <img src="../../../assets/images/Ellipse 12.svg" alt="bg-polygon" />
        </div>
      </div>
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pb-8 md:pb-8 pb-4 lg:pL-12 md:pl-12"
      >
        Testimonials
      </p>
      <div class="example-3d" @mouseenter="mouseover" @mouseleave="mouseleave">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide
            class="sm-h-auto cursor-pointer"
            v-for="(item, index) in testimonals"
            :key="index"
          >
            <div class="w-full p-8 cust-bg" @click="toggleDetails(true, item)">
              <div class="">
                <!-- <span class="text-0193a1 text-4xl"> ❝</span>
              <p>
                {{ item.text }}
              </p>
              <span class="text-0193a1 text-4xl"> ❞</span> -->

                <!-- <img :src="item.quotesImgopen" alt="quotesimg" class="w-4 h-4" /> -->
                <p
                  class="pt-2 clr777 font-normal fsize16px italic ellipsis-9 md-ellipsis-6"
                >
                  <span class="text-0193a1 fsize25"> ❝</span>
                  {{ item.text }}
                  <span class="text-0193a1 fsize25"> ❞</span>
                </p>
                <!-- <img :src="item.quotesImgclose" alt="quotesimg" class="w-4 h-4" /> -->
                <div class="mx-auto text-center">
                  <img
                    :src="item.userImg"
                    class="mt-6 rounded-full w-20 h-20 border-user mx-auto object-fill"
                    alt=""
                  />
                  <p class="pt-3 font-normal fsize14px text-black uppercase">
                    {{ item.name }}
                  </p>
                  <p class="text-sm pt-1 clr777 font-light">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination cust-posi" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

import TestimonialDetailsPopup from "./TestimonialDetailsPopup";
export default {
  components: {
    swiper,
    swiperSlide,
    TestimonialDetailsPopup,
  },
  data() {
    return {
      selectedTesimonial: {},

      testimonals: [
        {
          id: "01",
          // quotesImgopen: require("../../../assets/images/comma.png"),
          text: "I had not even thought about a role called Caregiver, until you started talking about Caregiver Saathi!  Honestly speaking, I had never felt that caretaking is a job in itself and how important it is in everyone’s life but when it comes to taking care of people fighting diseases, critical illnesses and behavioural issues, the same role of caregiving squeezes out our energy without even we realising it !",
          // quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/madhavi.jpeg"),
          name: "Madhavi",
          description: "Active Caregiver",
          html: `<p class="">I had not even thought about a role called Caregiver, until you started talking about Caregiver Saathi </p><p>Honestly speaking, I had never felt that caretaking is a job in itself and how important it is in everyone’s life but when it comes to taking care of people fighting diseases, critical illnesses and behavioural issues, the same role of caregiving squeezes out our energy without even we realising it !</p><p>Last few months have been quite unexpectedly strenuous and painful, with my mom being hospitalised with a heart failure and various other complications associated with age . With one family member seriously ill, the entire family has to cope up with an entirely different routine of hospital visits and attending to the daily chores too and needs a strong moral support to take care of the ailing person without making the person feel guilty or bad for their illness . It’s like caregivers need to carry a very positive attitude and carry a pleasant mood when with the ailing person . Infact the moods /feelings of caregivers are easily carried to the ailing person . This has been my experience.</p><p>It’s because of you with Caregiver Saathi that I realised how important it is to take care of ourselves so we can care for others even better !</p><p>Over the last few years, I have experienced that some souls chose me in their last phase and my journey with them has been a great learning and an enriching experience. Its a feeling of gratitude and blessing that I could be of service to these souls . I feel fortunate if these souls get some solace and peace in the service . For any little service I could do, I am grateful to the Lord for the opportunity.</p><p>Bhavana, its because of you and Caregiver Saathi that I realised how important it is to take care of ourselves so we can care for others even better !</p><p>Now I take time for myself to relax a bit, read and unwind without a bit of guilt . This me time I focus on empowering myself so I can be a greater support as a caregiver . This has helped me develop a more positive and happier outlook towards my role as a Caregiver.</p><p class="font-bold text-black text-lg my-2">Thank you very much Bhavana.
          </p><p>If I can be of any help to people, I will be more than happy to serve.</p>`,
        },
        {
          id: "02",
          // quotesImgopen: require("../../../assets/images/comma.png"),
          text: "A caregiver’s life is very tough, they need to be very practical, learn a lot very quickly, use social media very effectively, get in touch with the ‘heroes’ who have experience and also solutions. Share challenges and take all the guidance possible and try alternate therapies as then you know that you have tried everything possible.",
          // quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/Srikanth Batni.jpg"),
          name: "Srikanth Batni",
          description: "Active Caregiver",
          html: `<p class="">“A caregiver’s life is very tough, they need to be very practical, learn a lot very quickly, use social media very effectively, get in touch with the ‘heroes’ who have experience and also solutions. Share challenges and take all the guidance possible and try alternate therapies as then you know that you have tried everything possible.”</p>`,
        },
        {
          id: "03",
          // quotesImgopen: require("../../../assets/images/comma.png"),
          text: "Get a lot of counselling, talk out your problems, have faith and trust, show that you are there for them and that you will always support them. I took help of tools and techniques to break my own irrational beliefs (which really helped me a lot) and most importantly to create some ‘me’ time – (you absolutely need to take care of yourself first while caregiving.)",
          // quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/Shruti Dhawan.jpg"),
          name: "Shruti Singh Dhawan",
          description: "Active Caregiver",
          html: `<p class="">“Get a lot of counselling, talk out your problems, have faith and trust, show that you are there for them and that you will always support them. I took help of tools and techniques to break my own irrational beliefs (which really helped me a lot) and most importantly to create some ‘me’ time – (you absolutely need to take care of yourself first while caregiving.)”</p>`,
        },
      ],
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2.2,
        spaceBetween: 170,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          505: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      isDetailsActive: false,
    };
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    mouseover() {
      // console.log("sumit", this.swiper);
      this.swiper.autoplay.pause();
    },
    mouseleave() {
      this.swiper.autoplay.run();
    },
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 430px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 10px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
.testimonal-h650px {
  height: 650px;
}
@media (max-width: 640px) {
  .sm-h-565px {
    height: 565px;
  }
}
</style>
